var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUStarAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 12.4641 8.82819 13.4218 8.5 13.75C8.17181 14.0782 7.21413 17.25 6.75 17.25C6.28587 17.25 5.32819 14.0782 5 13.75C4.67181 13.4218 1.5 12.4641 1.5 12C1.5 11.5359 4.67181 10.5782 5 10.25C5.32819 9.92181 6.28587 6.75 6.75 6.75C7.21413 6.75 8.17181 9.92181 8.5 10.25C8.82819 10.5782 12 11.5359 12 12Z",
    fill: "#236BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6C16.5 6.26522 14.6875 6.81246 14.5 7C14.3125 7.18754 13.7652 9 13.5 9C13.2348 9 12.6875 7.18754 12.5 7C12.3125 6.81246 10.5 6.26522 10.5 6C10.5 5.73478 12.3125 5.18754 12.5 5C12.6875 4.81246 13.2348 3 13.5 3C13.7652 3 14.3125 4.81246 14.5 5C14.6875 5.18754 16.5 5.73478 16.5 6Z",
    fill: "#236BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.25C8.25 2.38261 7.34377 2.65623 7.25 2.75C7.15623 2.84377 6.88261 3.75 6.75 3.75C6.61739 3.75 6.34377 2.84377 6.25 2.75C6.15623 2.65623 5.25 2.38261 5.25 2.25C5.25 2.11739 6.15623 1.84377 6.25 1.75C6.34377 1.65623 6.61739 0.75 6.75 0.75C6.88261 0.75 7.15623 1.65623 7.25 1.75C7.34377 1.84377 8.25 2.11739 8.25 2.25Z",
    fill: "#236BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUStarAi);
export default __webpack_public_path__ + "static/media/u_star-ai.206251b7.svg";
export { ForwardRef as ReactComponent };